import { render, staticRenderFns } from "./GroupsCreateUpdate.vue?vue&type=template&id=04dd2593"
import script from "./GroupsCreateUpdate.vue?vue&type=script&lang=js"
export * from "./GroupsCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports